import type { TaskType } from '~/types/api/promo'

/** 后端 task.type → 展示名 / 单位（金额类走租户本位币，无单位文案） */
export const TASK_TYPE_META: Record<TaskType, { labelKey: string; unitKey?: string }> = {
  BET_TURNOVER: { labelKey: 'promo.daily.typeBetTurnover' },
  BET_COUNT: { labelKey: 'promo.daily.typeBetCount', unitKey: 'promo.daily.unitRound' },
  DEPOSIT: { labelKey: 'promo.daily.typeDeposit' },
  LOGIN: { labelKey: 'promo.daily.typeLogin', unitKey: 'promo.daily.unitDay' },
  PLAY_GAME: { labelKey: 'promo.daily.typePlayGame', unitKey: 'promo.daily.unitRound' },
}
